import { createSlice } from "@reduxjs/toolkit";
import {
  applyToJobThunk,
  getApplicationsThunk,
  getSingleApplicationThunk,
  scheduleInterviewThunk,
  evaluateRoundThunk,
  moveToNextRoundThunk,
  assignHRThunk,
  rejectCandidateThunk,
  getInterviewsbyStaffThunk,
  updateInterviewsbyStaffThunk,
  updateRoundCommunicationThunk,
  moveMultipleApplicantsToNextRoundThunk,
} from "./jobApplicationThunks";

const initialState = {
  applications: [],
  singleApplication: null,
  interviews: [],
  total: 0,
  page: 1,
  pages: 1,
  loading: false,
  error: null,
};

const jobApplicationSlice = createSlice({
  name: "jobApplications",
  initialState,
  reducers: {
    clearSingleApplication: (state) => {
      state.singleApplication = null;
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(applyToJobThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(applyToJobThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.applications.unshift(action.payload);
      })
      .addCase(applyToJobThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getApplicationsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getApplicationsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.applications = action.payload.data;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.pages = action.payload.pages;
      })
      .addCase(getApplicationsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getSingleApplicationThunk.fulfilled, (state, action) => {
        state.singleApplication = action.payload;
      })

      .addCase(getInterviewsbyStaffThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInterviewsbyStaffThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.interviews = action.payload;
      })
      .addCase(getInterviewsbyStaffThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateInterviewsbyStaffThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateInterviewsbyStaffThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateInterviewsbyStaffThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateRoundCommunicationThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRoundCommunicationThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateRoundCommunicationThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(moveMultipleApplicantsToNextRoundThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        moveMultipleApplicantsToNextRoundThunk.fulfilled,
        (state, action) => {
          state.loading = false;

          const updatedApplications = action.payload?.data || [];

          updatedApplications.forEach((updated) => {
            const index = state.applications.findIndex(
              (app) => app._id === updated._id,
            );

            if (index !== -1) {
              state.applications[index] = updated;
            }
          });
        },
      )
      .addCase(
        moveMultipleApplicantsToNextRoundThunk.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      )
      /* ---------------- UPDATE APPLICATION HELPER ---------------- */

      .addMatcher(
        (action) =>
          [
            scheduleInterviewThunk.fulfilled.type,
            evaluateRoundThunk.fulfilled.type,
            moveToNextRoundThunk.fulfilled.type,
            assignHRThunk.fulfilled.type,
            rejectCandidateThunk.fulfilled.type,
          ].includes(action.type),

        (state, action) => {
          const updated = action.payload?.data || action.payload;

          if (!updated?._id) return;

          const index = state.applications.findIndex(
            (app) => app._id === updated._id,
          );

          if (index !== -1) {
            state.applications[index] = updated;
          }

          state.singleApplication = updated;
        },
      );
  },
});

export const { clearSingleApplication } = jobApplicationSlice.actions;

export default jobApplicationSlice.reducer;
